import { render, staticRenderFns } from "./equiposSalaDigital.vue?vue&type=template&id=30fef318&scoped=true&"
import script from "./equiposSalaDigital.vue?vue&type=script&lang=js&"
export * from "./equiposSalaDigital.vue?vue&type=script&lang=js&"
import style0 from "./equiposSalaDigital.vue?vue&type=style&index=0&id=30fef318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fef318",
  null
  
)

export default component.exports